import { render, staticRenderFns } from "./TaskBox.vue?vue&type=template&id=4051ef46"
import script from "./TaskBox.vue?vue&type=script&lang=js"
export * from "./TaskBox.vue?vue&type=script&lang=js"
import style0 from "./TaskBox.vue?vue&type=style&index=0&id=4051ef46&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports